import { apiClient } from '@/app/api/client';

export interface EmailTemplate {
    template_id: string;
    template_name: string;
    template_type: string;
    subject_template: string;
    body_markdown: string;
    variables: any;
    description: string;
    is_active: number;
    created_at: number;
    updated_at: number;
    updated_by?: string;
}

export interface EmailLog {
    id: string;
    batch_id: string;
    recipient_email: string;
    template_id: string;
    subject: string;
    status: 'pending' | 'sent' | 'failed';
    provider: string;
    error_message: string;
    metadata: any;
    created_at: number;
    sent_at: number;
}

export interface SendTestEmailRequest {
    template_id: string;
    to: string;
    variables: Record<string, any>;
}

export const emailApi = {
    /**
     * Get all email templates
     */
    async getAllTemplates(): Promise<EmailTemplate[]> {
        const { data } = await apiClient.get('/api/email/templates');
        return data;
    },

    /**
     * Get template by ID
     */
    async getTemplate(id: string): Promise<EmailTemplate> {
        const { data } = await apiClient.get(`/api/email/templates/${id}`);
        return data;
    },

    /**
     * Init/Update a template
     */
    async saveTemplate(template: Partial<EmailTemplate>): Promise<EmailTemplate> {
        const { data } = await apiClient.post('/api/email/templates', template);
        return data.result;
    },

    /**
     * Send a test email
     */
    /**
     * Send a test email
     */
    async sendTestEmail(request: SendTestEmailRequest): Promise<any> {
        const { data } = await apiClient.post('/api/email/templates/send-test', request);
        return data.result;
    },

    /**
     * Get email logs
     */
    async getLogs(limit: number = 50, offset: number = 0): Promise<{ logs: EmailLog[], total: number }> {
        const { data } = await apiClient.get(`/api/email/logs?limit=${limit}&offset=${offset}`);
        return data;
    },

    /**
     * Get email settings
     */
    async getSettings(): Promise<any> {
        const { data } = await apiClient.get('/api/email/settings');
        return data;
    },

    /**
     * Update email settings
     */
    async saveSettings(settings: any): Promise<any> {
        const { data } = await apiClient.post('/api/email/settings', settings);
        return data;
    },

    /**
     * Test email settings configuration
     */
    async testSettings(settings: any): Promise<any> {
        const { data } = await apiClient.post('/api/email/settings/test', settings);
        return data;
    }
};

export const useEmailService = () => emailApi;
